import { DashboardContainer } from "../../containers/DashboardContainer";

export const Dashboard = () => {
	return <DashboardContainer />;
};
